module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Two")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("IT WAS")]), _vm._v(" probably stupid to come back to the island, but Jamie hadn’t exactly been thinking clearly when he decided to get away from LA. Too much booze, too much stress, and way, way too little sleep.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was only natural that he’d wind up on Bunker Island. After all, he’d spent so many winters here. Almost all the winters of his childhood, in fact. Fully half his youth spent scrambling across the uneven beaches, scavenging along the tide line, living more or less without supervision as long as he presented himself sometime around bedtime at one of the two houses that crowned King’s Terrace Hill. The two houses, sharing a garden wall and a gate, dominated the hilltop and could be seen from any part of the island. An easy landmark for a young boy to pick up in the middle of his adventures. When his parents were partying, he crashed the night at the house with the observatory, Uncle Fin’s, and when they weren’t he stayed in his own room in the house with the pergola.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The pergola. He sighed and rubbed his fingers up and down his forehead, as if he could scrub out the memory. “That’s the thing,” he muttered to himself as the boat slid serenely toward the dock. “I used to love that pergola, and you "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("ruined")]), _vm._v(" it for me. You selfish asshole.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What’s that, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He jumped and turned to see Drew, the skipper, standing behind him with a politely puzzled expression on her suntanned face.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh. Sorry, nothing, just….” He considered saying "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("talking to myself")]), _vm._v(", but everybody knew that was a sign of an unstable mind, even if everybody did it. And right now he really couldn’t afford for anybody to think he was starting to crack under the strain, even if he was. “Just making a mental list of stuff to do,” he lied.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She smiled and nodded, clearly not believing him. “We’ll have you on land in fifteen minutes,” she promised.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sure, great. Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Any idea how long you’ll be staying, sir?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Why?” he snapped, and then realized. “Uh. I haven’t given it much thought.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She shrugged. “I was just wondering if I should let some of the crew ashore and if we should pick up more fresh food and water.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh. Right.” Logistics. Things people needed to do so that his life could run the way it ran. He always was pretty self-absorbed and stupid about this kind of stuff. He nodded. “Yeah. Call it three days. There’s a resort here I wanna… no, make it a week. Give everybody a fucking break. Is a week a long enough break?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Her smile turned genuine. “Thank you, sir. They’ll be really pleased.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Good. Okay. So he’d done that right. Amazing. A miracle. First time for everything. Hip, hip, hooray, Jamie Durham did something without screwing it up. As soon as the boat touched the jetty, he hopped over the side and started walking.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("IF HE")]), _vm._v(" went up the only hill on the island, King’s Terrace, he’d wind up home. Well, he’d wind up in a place he’d grown up in, at a house he had the keys and the codes to and the right to stay in, but calling it "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("home")]), _vm._v(" was a bit of a stretch. The big house his parents had lived in had never been what you might call homey, and even if he had spent a lot of time in Uncle Fin’s house as a kid, it wasn’t his.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So where am I gonna actually go?” he asked himself, heading up the dock, past the harbormaster’s booth. “You gonna actually go to that cheesy resort, Jammers? Really? Even when there’s a whole big house you could go stay in?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He marched up the dock, wobbly underfoot, as wobbly as the morning of a bad hangover, and up to the shore, then across the sloping concrete of the boat ramp and down again. He looked up at the houses on the top of the hill and thought about the last time he had been on the island, six months ago, the annual winter family get-together that had started off bad and ended horribly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah,” he murmured to himself. “You’re damn right I’m going to that cheesy resort.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He hopped down the embankment to follow the shore. It was rough going here, big rocks made smooth by endless polishing of tide and time, but in not too long the big rocks diminished to pebbles, and as the resort came into view, the pebbles gave way to yellow-white sand.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He remembered the resort mostly from his youth. Sure, he’d seen it recently, but he hadn’t really paid much attention to it. After all, the resort had been here forever. They built it around the same time Hollywood stars colonized the island with their grand, ultra-modern homes. It boomed again in the ’70s, but when he was a kid, the place had been a quaint backwater. Now the resort, like the houses, was all faded glory. Around the time Jamie’s family bought the big house on the top of the hill and renovated the place into two homes, things started to look up for the island. More money came in, the old houses started to become classics, and vacationers started seeking out backwaters and secret spots rather than club vacation destinations.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Since they had mostly spent winters out here, Jamie remembered the resort being mostly empty. Even now, at the start of the summer season, it didn’t seem all that busy. The resort had never boomed the way Catalina and some of the other islands had. Instead it stayed quiet and low-key, boasting nothing more exciting than proximity to a reef that attracted the more serious divers and sometimes sunk boats, and a few refurbished bungalows set back on the beach. Just the thing to attract reclusive, screwed up weirdos like him. Perfect.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He had his wallet in his back pocket, his project and a few tools in the bag over his shoulder, and anything else he wanted he could buy in the little town or call Drew to bring him. He started up from the beach and angled toward the quaint little bungalows, each one of them perfect, with a little potted geranium near the door. Ridiculously quaint, something from fifty years ago, sitting on a pretty little beach dotted with a few families and their kids, a couple of old folks.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He’d stayed here before, in his early twenties, when things had gotten way out of control and the family lawyers had told him to keep his head down for two weeks. And he’d stayed here in his early thirties too, when he’d been the center of another total shit show. The place was exactly like it had been then. Wholesome. Boring. The last place on earth he could get into trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("BEN’S DATE")]), _vm._v(" was a mime.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And he was nice enough, born and raised in San Jose, and friendly, maybe even a little cheerfully baffled to find a pretty Asian American woman he didn’t know gesturing him over to a table three-quarters full and saying, “Hey, we’ve got an extra seat. Would you like to join us?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sure, a nice enough guy. Quiet, though. Unsurprisingly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They had a pleasant meal, and Ben, still tired from flying and airports and travel, zoned out a bit. Out in the bay, a stately white boat, not a yacht exactly, but not a speedboat either, went drifting by like a swan with its wings folded. He watched it go, passing the resort and turning toward the docks that stood at the foot of the big hill that dominated the island. There, enormous old-fashioned houses, the playgrounds and palaces of Hollywood stars long dead, stood shimmering in the golden afternoon sun.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He only dragged himself back to the conversation when the mime said good-bye and thanks and excused himself from the table, then drifted again, watching the sea and the sleek shape of the boat settling into its berth.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“So that’s a no on the mimes,” Nate murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What?” Ben asked. He sat up straight and realized that not only was the mime gone, so was Bree.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Washroom,” Nate said, guessing Ben’s question. “Not a big fan of mimery? Miming? Mimism? What the hell do you call it, anyway?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Mime,” Ben said. “Hey, uh, look—”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“If this is about the money, don’t even say it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s not.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate narrowed his eyes. “Okay,” he said, as if Ben was extremely untrustworthy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s about my dating life, or lack of it,” he amended, laughing weakly. “I don’t need help finding somebody.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate raised an eyebrow at him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben sighed. “Okay, yes, I know. I tend to swim in the same circles over and over again. It’s just that I know what I like, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate sat back in his chair. “Liam,” he said. “Matt.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Come on. Are you seriously going to hold two bad relationships over my head forever?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“They are the only two long-term relationships you ever had.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Well….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“And you met them both in high school.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah, but….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Benji, I would never have said this to you if you were still dating either of them, but Matt was a total jerk.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I know. I "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("know")]), _vm._v(".” Ben spread his hands. “I get weak around the cute ones.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Then you shacked up with Liam, and that guy was such an asshole that he cheated"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("on you when you were in the "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("hospital")]), _vm._v(". And then he took off and left you minus a bunch of your stuff.” Nate sighed and leaned forward again. “You like being comfortable. You like what you know. But we’re not kids anymore. We’re all over thirty. Everybody in our social circle is with somebody, and the people who aren’t….” He hesitated. “There’re reasons. Look at Hendry.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hendry’s a nice guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sure, he’s "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("nice")]), _vm._v(", but man, he’s constantly broke. He will drain you dry. He’ll be a real sweetheart when he does it, and he won’t mean to do it, but you’re still going to be broke. Rob’s no good either,” he added.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben rolled his eyes. “Okay, Dad, tell me what’s wrong with Rob.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate frowned at him. “C’mon. Have you ever had a conversation with him where he talked about something other than himself?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben shut his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I rest my case.” Nate shrugged. “You can’t go fishing in our pond anymore, man. I like those guys too. Great to see them and have a beer together. But they are not good enough for you.” Nate smiled wryly. “Look, I’m sorry. It’s just, I want you to have what you deserve, and those other guys? They’re not it. You deserve better than the leftovers from our social group. I know you like being comfortable, but maybe… maybe you need a little change in your life.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben looked down the table. The trouble was Nate wasn’t wrong, not about any of it. Both Hendry and Rob were bad potential boyfriends, and yes, he’d been thinking about asking both of them out. And yes, Ben had always preferred familiar faces to new ones. Just like he liked watching the same comfortable old movies over and over. Just like he was planning on going back to work at the job that had almost killed him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Isn’t it better to have to deal with the devil you know?” he asked, looking up at Nate again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate’s eyebrows bunched above his nose. “Benji,” he said sternly, “you’re picking an apple you know is rotten because you’re worried about getting one with a bruise. That doesn’t make sense.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben sighed. “Okay, fine, point made. But please. Don’t try and set me up anymore. I’m not into that kind of thing. It makes me uncomfortable.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate blinked. “What?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Always filling the fourth chair? That thing?” Ben said, pointing at the empty chair.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh my God, no, that’s not a date thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Come on.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No, seriously. Bree’s kinda intense about that. When I got the dining room set for the house? I had to put two of the four chairs in the garage. She hates empty chairs at meals.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben frowned. “Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Because a ghost might fill it,” Bree said primly, returning to the table. Ben blinked at her in surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You really believe that?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She shrugged. “I don’t know if I’d say ‘really believe,’ but let’s say it makes me "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("really ")]), _vm._v("uncomfortable to see an empty chair at the table at dinner. My grandma drilled it into me pretty darn good.” She yawned and stretched. “So there was a girl in the restroom who said there’s a really good ice cream place just outside the resort. Who’s up for it?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben shook his head. “Naw, you guys go ahead, I’m….” He saw the knowing look Nate and Bree cast each other. It was only a flicker, but he saw it all the same. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Boring Ben, never wants to do something new.")]), _vm._v(" He tamped down the irritation. “Actually, that sounds great,” he lied.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bree’s eyebrows went up. Nate’s mouth dropped open. He closed it and grinned.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Next thing I know, Mr. Sixty Dollar Haircut will be trying something that’s not vanilla,” he murmured, getting to his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey, hey,” Ben said. “Let’s not get too crazy here.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("THE ICE")]), _vm._v(" cream place was a little storefront that stood between the edge of the resort and Bunker Cove, the little town of mostly year-round residents who worked in the big houses on King’s Terrace or kept the resort running. The lineup for ice cream was about four people deep, and Ben felt sorry for the kid doing the scooping. It was probably the busiest the place had ever been.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Two of the vanilla,” Ben said. He scowled at Bree and Nate.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What?” Nate asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s a preemptive glaring. Because I know you’re going to mock me.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Ooh,” Bree said. “That’s a sign that we’ve been overmocking. We should tone it down.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“But Bree,” Nate whined, “"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("vanilla")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey.” Ben jabbed Nate in the chest with one finger. “Vanilla comes from the stamen of a South Pacific orchid. It’s about as exotic as it gets.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate snorted. “Never heard the term"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(" plain vanilla")]), _vm._v(", huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“People who use that term are idiots,” Ben said, accepting the cone from the kid and smiling his thanks.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate rolled his eyes. “Two words for you, man.” He gestured to his own cone. “Birthday. Cake.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bree elbowed him in the ribs. “Hey, lay off him just a little, would you? He’s out here on vacation, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("and")]), _vm._v(" he didn’t go right back to his room to watch movies. How much more do you want from the guy?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate muttered something Ben couldn’t catch, and Bree rolled her eyes and smiled at Ben.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We’ll chill out a bit,” she promised. “Nate’s just incredibly happy you’re alive, and he shows his affection by bullying. It’s a bad habit.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sorry,” Nate muttered. He took a bite out of his ice cream. “I’m working on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben smiled gratefully at Bree, and she winked back.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("THEY TOOK")]), _vm._v(" their cones and made a slow, circuitous route back toward the resort, fingers and mouths sticky with melting ice cream by the time they reached the gates.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Turns out there’s a beginner’s dive course here,” Nate said. He sucked some ice cream from his thumb. “You ever wanted to try diving?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Can’t.” Ben popped the end of his cone into his mouth and crunched down. “And before you ask, I mean it. Can’t. Really.” He tapped himself on his chest. “I mean, maybe I "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("could")]), _vm._v(", but I’d need to go in for a full evaluation and get an all clear. Surfing’s fine, skiing’s fine, weight lifting’s fine, but anything with different pressures, I don’t know….” He shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bree nodded. “Too bad, the water here is great. I was thinking it’d be nice if you could come out and see the wreck. Two weeks would be enough time to uh….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They all stopped walking as a grubby-looking guy in a stained hoodie and dirty jeans walked in front of them. He was moving fast, heading for the reception desk, body angled forward as if someone in there had done something to offend him personally and there was going to be a fight.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Whoa,” Ben said, catching a whiff of not enough showering as the guy passed. He looked and then looked again. The guy’s face was familiar from magazine stands and daytime TV. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Jamie Durham.")]), _vm._v(" “Wait, whoa.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No kidding,” Bree murmured, staring after Jamie Durham. She glanced at Nate, who made a face and shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh, c’mon. Everybody needs a vacation.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah, but his family owns the top of that hill. Why’s he even here?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Buying the resort?” Nate asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bree pursed her lips, then shook her head. “Did not look like a business deal going down.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“In hiding,” Ben suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate laughed. “Now that sounds like Jamie Durham.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“True enough,” Bree agreed. They started walking again, over warm concrete, toward the yellow sand. “So,” she said. “Got any plans for when we’re gone?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben shrugged. “Since there are reservations for four all week, I’ll probably spend the next two days trying to wrangle a date.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bree smiled fondly at him. “Honestly, if it drives you crazy I will totally call and make it for three.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No, it’s fine. It’s….” He considered. It wasn’t just his pride, but it was "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("mostly")]), _vm._v(" his pride. So he lied. “There’s somebody I want to ask, anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Really?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Surf-shop Hank,” Nate said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Surf-shop Hank,” she agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Surf-shop Hank. Easygoing, friendly, cute. Maybe your type. I recommend asking him.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You guys, I will find my own damn date. I can do it all by myself. I am a big boy.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate snorted. “You’re not wrong,” he murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bree groaned and shoved him. “Seriously, Nate, TMI.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben covered his face with his hands and took a deep breath. “Okay, listen to me, you two wackos. Stop. Trying. To. Set. Me. Up. I will find my own date. I do not want to show up for dinner only to see that dude”—he jerked his chin at the guy in the hoodie’s retreating back—“sitting in the fourth chair. Got it?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bree looked at him, her eyes wide. Then she looked at Nate, and both of them burst out laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I promise you,” Bree said between peals of laughter, “that is "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("not")]), _vm._v(" going to happen.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("BECAUSE BEN")]), _vm._v(" was remarkably unlucky, in spite of what Nate said, Jamie Durham, troubled son of a famous pop-music duo, both dead, wound up in the bungalow next to Ben’s, number eight. And, Ben thought as he tried to watch the guy while pretending to watch a movie on his tablet, the dude seemed to be having as much trouble relaxing as Ben was.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Two days ago, when Ben rolled out of bed early to walk on the beach and watch the sunrise turn the world from velvet blue to vivid orange to pale pink and finally to day, he found his neighbor standing on the beach alone too.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Morning,” Ben called.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jamie looked at him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Looks like it’s going to be a nice day,” Ben said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jamie scowled. “Are you fucking "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("kidding")]), _vm._v(" me?” he asked, and then stomped off back to his bungalow.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Yesterday morning the guy had appeared just as Ben was returning from his early morning walk along the beach, spotted Ben, and then gone back inside. Which suited Ben just fine, considering how weird the dude was.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("HE ENJOYED")]), _vm._v(" himself in spite of his weird neighbor. The whole of Bunker Island was breathtaking long beaches, and about sixty years ago, in the golden age of Hollywood, it was where stars had come to get away from it all.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Now the palm trees were towering and elegant, the houses aged from out-of-date and right back into beautiful again. The few cars that were on the island were testament to its return to a playground for the well-to-do. He’d seen a few Audis, an impeccably clean white Porsche, and once he even saw that bright yellow Lamborghini, trying hard to navigate a tight corner on the switchback hill that made up King’s Terrace. One of the Durhams, Bree had said.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben spent a more than usual amount of time looking up at the Durham houses. They were more or less impossible to miss—visible from any spot on the island, huge, white-faced Italian style. They were identical in terms of construction, but the east-facing house had a pergola heavily draped with purple flowers that fell in gorgeous bunches as if they were grapes, and the west-facing one stood a few feet taller, surmounted by a dome that could only be an observatory.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben had stared at them in something like a reverential awe. The beauty of the old architecture, the elegance of old Hollywood. Those two houses, like twins, looked out to sea.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And if Ben was being honest, the place was made even better by the people who currently vacationed here. Bunker Beach, he found out early, was a haven for surfers. This meant the beach was absolutely "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("full")]), _vm._v(" of good-looking men who happened to spend a lot of the day in surf shorts. Ben had even, God help him, booked a lesson with Hank, the gorgeous blond at the surf shop.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Ever surfed before?” Hank had asked him, smiling and professional and friendly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben fumbled. “Uh. Uh, no. I, uh….” The fact was, the only reason he’d taken an interest in surfing was because of Nate.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("They’d been sitting in front of Nate and Bree’s bungalow on the deck chairs, drinking beers and talking while Bree lay out on the sand, face toward the sun.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“We’re heading back to the wreck tomorrow,” Nate had said. “You want to come?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben shook his head. “I don’t have a dive ticket, remember?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate had waved his hand in the air like Ben’s lack of expertise was about as irritating as flies. “Don’t really need one. I forgot we bought a bubble sub.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben frowned. “A what-what?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Bree looked over at them and sat up, dusting sand from her belly. “Nate, are you hassling Ben?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Maybe,” Nate said. He looked back at Ben. “It’s a personal submersible. Low pressure, ambient air gets pumped in, no fancy gas mixes. Easy to use. Don’t need a ticket, and it doesn’t go down very far.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Can’t,” Ben said, suddenly desperate to get out of it. It wasn’t just the dislike of new things; it was the thought of pressure on his chest too. Forget it. “Sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Can’t or don’t want to?” Nate asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Can’t. Got a….”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nate narrowed his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Lesson,” Ben blurted. “Got a surf lesson tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Really?” Nate asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Really,” Ben lied earnestly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“See?” Bree scowled at Nate. “Leave the poor guy alone. He can look after himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Okay, okay.” Nate slouched in his chair and hid his face behind his beer bottle. “My bad. I’ll lay off.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("So after that, of course, he had to book a surf lesson.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Which wasn’t easy, because surf-shop Hank, as Bree and Nate called him, was frankly gorgeous, and Ben had never been what people would consider "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("smooth")]), _vm._v(" around the guys.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Sorry?” Ben said, realizing Hank had asked him a question and he hadn’t answered yet.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I asked if you’ve surfed before.” Hank smiled, cocking his head so his salt-curled hair covered the corner of one eye. Ben swallowed with a mouth suddenly very, very dry.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Uh. No.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Hank’s smile grew fractionally. “Well,” he said, nodding at Ben, “guessing from your physique, you’re going to get pretty tired on your first day.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Ouch.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It takes a lot of work to go from couch potato to surfer, but if you work hard, you’ll develop the muscle.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Jesus")]), _vm._v(". Ben could feel the heat in his face.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’m recovering from heart surgery,” he said, wanting to explain himself and then hating himself for doing it. “I think I know about hard work.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Perfect,” Hank answered. He slapped Ben on the arm. “I’ll find you a board and get you set up with the beginner’s package. Beginners go out with Amanda tomorrow at ten. How does that work for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("At least he wouldn’t be learning to surf in front of Mr. Good-looking Judgmental-Pants. “Great,” he mumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Meet at the surf shop to get the board and the basics,” Hank said, steering him toward the cashier. “And if you’re a natural, I’ll take you under my wing in the advanced class.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben said, “Thanks,” because that was the only nice thing he could think of to say.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("At least Amanda, the beginners’ instructor, was friendly and helpful as she measured him for a board and gave him the little waterproof bracelet that was his ticket to the beginners’ class.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He still felt frayed and wrung out from Hank as he was leaving. He’d always been a bigger guy, and hard work had kept most of that muscle. The surgery and the resting that came with it had stripped a lot of that away, though physical therapy and regular gym time was helping manage that. Besides, it was nobody’s business but his, damn it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Fuck new things")]), _vm._v(", he thought as he retreated."), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(" New things are ")]), _vm._v("really"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(" hard.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("BUT IT")]), _vm._v(" wasn’t all difficult. It turned out Ben was actually a bit of a natural at surfing. Amanda had him demonstrate a couple of times. Still, he wore a shirt with his surf shorts and was the only guy who wasn’t bare-chested by the end of the lesson. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("The scar’s really ugly")]), _vm._v(", he told himself. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Nobody wants to see that on vacation.")]), _vm._v(" He found himself looking around for Good-looking Judgmental-Pants a few times, but Hank was nowhere to be seen. Didn’t really matter. He still felt like everyone on the beach was watching him fall off the board again and again and again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("HE WAS")]), _vm._v(" glad when the lesson was over. Not that he was struggling; he was actually doing pretty well, but getting too tired and too sore to keep on. When the class broke up, Amanda invited him back for the 2:00 p.m. class, but he begged off.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He went back to his bungalow and napped, then made himself some dinner and went out to lounge on the porch, wrapped in a scratchy picnic blanket, listening to the sighing sea and the gulls, and watching black-and-white movies on the tablet. Not bored. Alarmingly unbored. Alarmingly unexcited to go back to work. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Give it some time")]), _vm._v(", he told himself, queuing up "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Bringing Up Baby")]), _vm._v(", his favorite comedy,"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("to follow the heavy slog of "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Gaslight")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was late, and most of the bungalows were shuttered and dark. Sometime around the point in "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Bringing Up Baby ")]), _vm._v("where the two main characters realize they don’t actually hate each other and they’re actually in love, the music started up.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It took Ben a second to realize the noise wasn’t coming from an app on his tablet or from his phone. The noise was coming from bungalow number eight.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Green Day, loud. Very loud. Followed by AC/DC. Followed by Cub. He went inside and closed the door. By nine he realized the door was insufficient for blocking the noise and even headphones weren’t enough to let him focus on the movie. By eleven he was lying in bed with a pair of worksite earplugs stuffed into his ears, muscles aching with exhaustion from the surfing, wondering if he could heave himself out of bed and go give Jamie Durham a piece of his mind. He was trying to decide when he fell asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("IN THE")]), _vm._v(" morning, the beach was quiet again. He woke with the yellow sun falling through the curtains and warming his feet and the sigh of wind and waves and no hint of the racket from last night.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He got up, made breakfast and coffee in the tiny kitchen, made a note of groceries to pick up, then went out to the porch to enjoy the cool, quiet morning.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Another cloudless day, the sun glowing butter yellow, the sky a hard enamel blue, and white gulls bobbing on the air currents and piping at one another at the tide line. He smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It occurred to him that the stiffness in his core and in his arms was the pleasant kind, the sort that meant muscles well used but not overused. He surfed in the morning (it was easier now), saw Bree and Nate off to the wreck after lunch, and then wandered the island. The rest of the day passed like a good dream. He explored the island’s long, sandy beaches and went down to the marina to see the yachts moored there, then had lunch on the porch and watched a pair of kids get a kite into the air, then run up and down the beach shrieking with delight.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("In the evening he wound up back on the porch again, with a cup of coffee in hand and "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Casablanca ")]), _vm._v("on the tablet. But he didn’t bother watching it. Instead he watched the endless, rolling waves and found himself smiling faintly at nothing at all.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Here he was, at a fancy resort at the end of a long and blissful day, with the sun sinking in the crimson sky, golden-age Hollywood memories all around him, drinking coffee and watching the waves turn from daytime blue to wine-dark purple. He’d started learning to surf, explored unknown beaches, rubbernecked at the Hepburn family’s summer house/museum. He wasn’t just alive, Ben realized, he was actually living for a change. He sipped the coffee and savored it. Life was good. At this moment, life was very good indeed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Which was, of course, when the music started up.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Too loud, pumped out of inadequate speakers, and carried right from number eight over to Ben’s without losing much in the way of clarity or volume. The sense of calm well-being that had suffused him evaporated, and he found himself rubbing at the place where the scar peeked up above the neckline of his shirt, as if it was the scar that was bothering him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I’ll finish my coffee,” he murmured to no one in particular. “Then I’ll go over and talk with that joker.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Which was when the lights flickered and the smoke detector in the bungalow beeped twice. Then there was a "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("crack")]), _vm._v(", and all his lights went out. The smoke detector made a distressed, warbling sort of "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("peep")]), _vm._v(", and the scent of burned plastic drifted over.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Are you "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("kidding?")]), _vm._v("” Ben muttered, setting aside his cup and getting to his feet. “Are you seriously going to do this tonight too?” He fumbled around for the electrical panel and flicked all the breakers back over. The light flickered, the smoke detector beeped, and then the fuses thumped back to the "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("off ")]), _vm._v("position, and everything went dark and silent again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben sighed. He considered groping around in the dark for his shoes, but decided against it. Between this one and the other bungalow, there was just a long stretch of powdery yellow-gray sand, occasionally hummocked with hard-edged gray grasses. He made the trek, stepped up onto the weathered silver wood of the porch, and strode to the door, knocked, and waited. And waited. And waited some more. And "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("kept")]), _vm._v(" waiting.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He knocked again, harder this time, just as “Thunderstruck” was winding to its long-awaited conclusion. Something rattled in the bungalow. The door opened, and Jamie Durham, darling of the tabloids, opened the door. And if Ben hadn’t known who he was, he would have thought the guy was a squatter.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jamie’s hair was screwed up as if he hadn’t combed it for days. He had two days’ worth of patchy stubble, and his shirt and jeans were both dirty, the jeans almost greasy looking. His eyes, which were blue, were threaded with red veins and underscored by dark circles. He looked, Ben thought, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("really fucking tired")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Didn’t order room service,” Jamie said and started to close the door.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben put his hand on the wood.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey, I’m not room service. I’m your neighbor. You blew the lights. You kept me awake all night last night too.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The guy sighed and rolled his eyes. “These little crap holes were wired in the twenties, and nobody’s bothered to rewire them. That’s the "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("problem")]), _vm._v(" with the modern world. If it’s good enough, nobody cares about making it better.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“A real crime,” Ben muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jamie’s eyebrows went up, he leaned forward, pointing with his index finger, and then Ben’s tone must have registered because he scowled.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Go flip your breakers. They’re in the panel above the kitchen sink.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He started to close the door. Ben put his hand on the wood again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Hey, I know where the damn breakers are. You mind not playing your music so loud?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“What?” Jamie asked. “Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Because I can hear it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“It’s "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("music")]), _vm._v(". You’re supposed to hear it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben took a deep breath to steady himself. “I don’t "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("want")]), _vm._v(" to hear your music. I came out here to listen to the waves and the birds. I can hear AC/DC at home.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“But not the waves and the birds?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jamie laughed. “Dude, you ever hear of a thing called the Internet? You can stream waves and birds any time you like.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben closed his eyes to calm himself. “Look, if you keep playing your music so loud and you keep blowing my breakers, I’m going to have to talk to the management, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jamie’s eyes opened wide, and he laughed again. “You go right ahead and do that,” he said and pushed the door closed in Ben’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben stood there, nose half an inch from the weathered silver wood of the door, angry in a way he hadn’t been for years.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("IT WAS")]), _vm._v(" late when Ben finally felt tired enough to go to sleep. He put out the lights in the bungalow and then remembered the curtains in the kitchen were still open, and the idea of somebody being able to look in and watch him while he slept made his skin crawl. He picked his way across the floor to pull the curtains closed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Outside, over at number eight, a dark figure was ducking out the door. The moonlight silvered his outline: blond hair, big shoulders, a surfer’s physique. Hank, sneaking out of the bungalow.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Are you fucking kidding me?” Ben asked nobody in particular.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Hank pulled the door closed and started across the beach, hopped up the boardwalk, and disappeared in the direction of the main building.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“How does an asshole like that get "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("laid")]), _vm._v("?” He did not want to admit jealousy, even though he felt it twisting in his belly.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He slept badly, nursing his anger all through the night. The guy hadn’t even bothered to pretend to be sorry. He hadn’t even bothered to pretend to care. And at two in the morning, when the Jolly Fools were blasting through what should have been a still and soft night full only of the sigh of the waves, he rolled over in bed and set his alarm. The office opened at eight, so he set the alarm for seven thirty.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sometime closer to dawn than midnight, the music stopped, and Ben felt like a headache had finally let up, and all the muscles he’d been clenching finally relaxed. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("What a jerk. ")]), _vm._v("It might have been his last thought before he fell asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("IN THE")]), _vm._v(" morning his alarm chirped him awake, and he rolled out of the tangle of bedclothes grumpy and sore and sandy-eyed. He staggered around the little room getting dressed in yesterday’s clothes, jammed his feet into his shoes, and let himself out. He entertained a fantasy of going over to the neighboring bungalow and, he didn’t know, coughing loudly right outside the window, or maybe hammering on the door and then running away, just to get revenge. But it seemed childish and stupid, and anyway, Ben really did wonder if the guy was supposed to be here at all.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He was relieved to discover the clerk at the front desk was Zu. She looked up from whatever she had been doing and smiled a bright, professional smile.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Good morning,” she started, and then stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She must have noticed his face. He hadn’t even combed his hair. He passed a hand over it, nervously pushing where he felt it sticking up.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Oh,” she said. Her expression changed to one of resigned sympathy. “You’re in number seven, aren’t you?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Don’t tell me that bag of dicks is actually a guest,” he said, then realized what he’d said. “I’m sorry. I didn’t mean to say that out loud. Didn’t get much sleep last night.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She nodded, straightening up. “Did he blow out your fuses?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“This is a "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("thing")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She made a face. “Yeah. Sorry. The wiring’s old, and those two bungalows share the same electrical.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He sighed. “Can’t you ask him to leave? Or maybe move him to another cabin? Or move me?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She sighed. “I’m so sorry. We’d move you if we could, but half the bungalows are being reno’ed, and the other ones are full.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben sighed.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You want some coffee?” Zu asked. She jerked her chin toward the restaurant, currently empty, the tables draped in white and the big windows framing the idyllic ocean blue. “I can comp you the continental breakfast for your trouble, and no offense, but you look like you could use some coffee.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He sighed and nodded. “Yeah,” he said. “Thanks, uh… I’m Ben,” he added.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Ben in number seven,” she said, nodding. “I remember. Zu,” she said, gesturing to herself. “In case you don’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yeah. Like, short for Susan? From "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("It’s a Wonderful Life")]), _vm._v("?”"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }), _vm._v("he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She laughed. “Exactly. When I was a kid I couldn’t say it, and it kinda stuck.” She shrugged. “You’re here for another week and a bit, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("She hummed softly. “Okay, Ben in seven, I’ll see what I can do about Jamie in eight, and if we can’t move you, or get him to quiet down, I’ll talk to the boss and see what we can comp you. Is that okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ben sighed and nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Thanks,” he mumbled, trying not to sound ungrateful.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("HE DRANK")]), _vm._v(" two coffees and ate an enormous breakfast. Surfing, he figured. It had done something to his appetite.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When he got back to the bungalow, the sun was warming the surface of the sand, gilding the tops of the waves, and turning the weathered gray larch cladding of his bungalow a mellow honey brown. Gulls swooped and sailed on the breeze, and the sea grasses bowed and danced beside the boardwalk. He found himself smiling again, in spite of it all. The place was gorgeous, and all his life he had wanted to visit a piece of old Hollywood. He was lucky to get to come at all, considering the hospital bills at home.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He hopped up onto the porch. A tall paper bag sat propped against his door.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He bent down and picked it up. Inside there was a long, narrow box, purple, with an image of a highland moor on it, and a clear plastic bag at the bottom of the works. Ben popped the box open and found a bottle of whiskey inside. He stared at it. The stuff looked like money—thick box with embossed gold lettering, heavy black-and-gold foil on the neck of the bottle, and whiskey the color of amber.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Nestled under that he found a plastic sandwich bag with two pellets of bright pink foam, the sort of thing Ben had spent his whole life rolling into little balls in his pockets and accidentally putting through the wash. Heavy-duty foam earplugs, the ones found on every worksite. These were still in their little plastic wrappers. And underneath those was a piece of yellow paper on which someone had written, in a fast, angular scrawl, the words, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Peace offering.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("I’m not a total dick")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Actually,” he said to the bag, “you absolutely are.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He pushed his way inside.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0